var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    zoomAndPan: "magnify",
    viewBox: "0 0 139.5 60",
    height: 80,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#efc725",
    d: "M 34.023438 47.816406 L 30.476562 7.988281 L 69.480469 7.988281 L 65.929688 47.808594 L 49.953125 52.238281 Z M 34.023438 47.816406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbde34",
    d: "M 49.945312 48.804688 L 62.851562 45.222656 L 65.886719 11.195312 L 49.945312 11.195312 Z M 49.945312 48.804688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 49.9375 38.65625 L 49.917969 38.664062 L 44.476562 37.191406 L 44.128906 33.296875 L 39.226562 33.296875 L 39.914062 40.96875 L 49.914062 43.742188 L 49.9375 43.738281 Z M 49.9375 38.65625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 50.59375 30.851562 L 50.59375 25.96875 L 44.582031 25.96875 L 45.289062 18.300781 L 50.613281 18.160156 L 50.59375 13.082031 L 40.875 13.082031 L 40.511719 16.683594 L 39.363281 29.542969 L 39.242188 30.851562 Z M 50.59375 30.851562 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 50.5625 18.171875 L 50.582031 18.160156 L 55.917969 18.484375 L 56.371094 23.527344 L 61.269531 23.527344 L 60.417969 14.089844 L 50.582031 13.082031 L 50.5625 13.085938 Z M 50.5625 18.171875 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 60.769531 18.183594 L 60.347656 13.082031 L 50.042969 13.082031 L 50.042969 18.183594 Z M 60.769531 18.183594 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 49.921875 25.972656 L 49.921875 30.855469 L 55.933594 30.855469 L 55.367188 37.191406 L 49.921875 38.660156 L 49.921875 43.742188 L 59.929688 40.96875 L 60.003906 40.144531 L 61.152344 27.285156 L 61.269531 25.972656 Z M 49.921875 25.972656 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    d: "M 109.753906 26.222656 L 102.242188 26.222656 L 110.054688 34.703125 L 110.054688 38.738281 L 93.960938 38.738281 L 93.960938 34.011719 L 101.773438 34.011719 L 93.960938 25.53125 L 93.960938 21.488281 L 109.753906 21.488281 Z M 109.753906 26.222656 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M 91.09375 21.496094 L 91.09375 38.730469 L 77.234375 38.730469 L 77.234375 33.035156 L 85.332031 33.035156 L 85.332031 21.496094 Z M 91.09375 21.496094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.802095ab9fc927f711803db2609d9486.svg";
export { ForwardRef as ReactComponent };